/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import Timeframe from '@linc-technologies/linced-common/models/timeframe';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import moment from 'moment';

// Proto: dates.Timeframe.
export default class _Timeframe extends Timeframe {
  declare [Type]: 'timeframe';

  @computed('startDate', 'endDate')
  get dateValidation() {
    return [
      {
        message: `Timeframe ends before it starts.`,
        validate: () => {
          if (isEmpty(this.startDate) || isEmpty(this.endDate)) {
            return true;
          }
          return this.dateValidate;
        },
      },
      {
        message: `Incorrect year.`,
        validate: () => {
          if (isEmpty(this.startDate) || isEmpty(this.endDate)) {
            return true;
          }
          return this.yearValidate;
        },
      },
    ];
  }

  @computed('startDate', 'endDate')
  get dateValidate() {
    if (isEmpty(this.startDate) || isEmpty(this.endDate)) {
      return false;
    }
    // TS-ZERO(startDate, endDate): isEmpty does not narrow undefined.
    return this.endDate! >= this.startDate!;
  }

  @computed('startDate', 'endDate', 'year')
  get yearValidate() {
    if (isEmpty(this.startDate) || isEmpty(this.endDate)) {
      return false;
    }

    const startDateYear = moment(this.startDate).year();
    const endDateYear = moment(this.endDate).year();
    const currentYear = parseInt(this.year);

    return startDateYear === currentYear && endDateYear === currentYear;
  }
}
